import { supabase as _supabase } from './supabase';

const db = _supabase as any;

export type PartnerActivityType = 'programs';

export interface PartnerUnseenCounts {
  programs: number;
}

export async function fetchPartnerUnseenCounts(partnerUserId: string): Promise<PartnerUnseenCounts> {
  const { data: partner } = await db
    .from('partners')
    .select('id')
    .eq('user_id', partnerUserId)
    .maybeSingle();

  if (!partner) return { programs: 0 };

  const { data: coaches } = await db
    .from('coaches')
    .select('user_id')
    .eq('partner_id', partner.id);

  if (!coaches || coaches.length === 0) return { programs: 0 };

  const coachUserIds = coaches.map((c: { user_id: string }) => c.user_id);

  const { data: seenRows } = await db
    .from('coach_activity_seen')
    .select('activity_type, last_seen_at')
    .eq('coach_id', partnerUserId);

  const seenMap = new Map<string, string>();
  (seenRows || []).forEach((r: { activity_type: string; last_seen_at: string }) => {
    seenMap.set(r.activity_type, r.last_seen_at);
  });

  const programsSince = seenMap.get('programs') || '1970-01-01T00:00:00Z';

  const { count: programsCount } = await db
    .from('program_assignments')
    .select('id', { count: 'exact', head: true })
    .in('assignee_user_id', coachUserIds)
    .not('completed_at', 'is', null)
    .gte('completed_at', programsSince);

  return { programs: programsCount || 0 };
}

export async function markPartnerActivitySeen(partnerUserId: string, activityType: PartnerActivityType): Promise<void> {
  const now = new Date().toISOString();
  const { data: existing } = await db
    .from('coach_activity_seen')
    .select('id')
    .eq('coach_id', partnerUserId)
    .eq('activity_type', activityType)
    .maybeSingle();

  if (existing) {
    await db
      .from('coach_activity_seen')
      .update({ last_seen_at: now, updated_at: now })
      .eq('id', existing.id);
  } else {
    await db
      .from('coach_activity_seen')
      .insert({ coach_id: partnerUserId, activity_type: activityType, last_seen_at: now });
  }
}
